import "./Footer.css";
export function Footer() {
  return (
    <>
      <p className={"footer"}>
        Copyright 2023 - 2026 Tomasz Laboj
        <br /> GitHub repos:{" "}
        <a href="https://github.com/TomaszLaboj/to-do-list-tomasz-laboj">
          front end
        </a>{" "}
        and{" "}
        <a href="https://github.com/TomaszLaboj/to-do-list-back-end-tomasz-laboj">
          back end
        </a>
        .
      </p>
    </>
  );
}
